<template>
  <div>
    <h3>云豆明细</h3>
    <el-form
      :inline="true"
      class="demo-form-inline"
      :loading="loading"
      size="mini"
    >
      <el-form-item label="用户id">
        <el-input placeholder="用户id" v-model="filter.userId"></el-input>
      </el-form-item>
      <el-form-item label="角色">
        <el-select v-model="filter.role">
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="(label, key) in partyS"
            :key="key"
            :label="label"
            :value="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="filter.type">
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="(label, key) in types"
            :key="key"
            :label="label"
            :value="key"
          ></el-option>
          <!-- <el-option label="人才沟通消耗" value="-3"></el-option> -->
        </el-select>
      </el-form-item>
      <el-form-item label="时间范围从">
        <el-date-picker
          v-model="filter.startTime"
          type="datetime"
          placeholder="开始时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker
          v-model="filter.endTime"
          type="datetime"
          placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="fetch(1)">查询</el-button>
        <el-button type="primary" size="mini" @click="exportExcel()"
          >导出</el-button
        >
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini">
      <el-table-column prop="id" label="id"></el-table-column>
      <el-table-column prop="userId" label="用户id"></el-table-column>
      <el-table-column prop="role" label="角色">
        <template slot-scope="scope">{{
          scope.row.role === 2 ? "乙方" : "甲方"
        }}</template>
      </el-table-column>
      <el-table-column prop="type" label="类型">
        <template slot-scope="scope">{{
          scope.row.type == -3 ? "人才沟通消耗" : types[scope.row.type]
        }}</template>
      </el-table-column>
      <el-table-column prop="num" label="数量"></el-table-column>
      <el-table-column prop="balance" label="余额"></el-table-column>
      <el-table-column prop="createTime" label="更新时间"></el-table-column>
    </el-table>
    <br />
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="limit"
        @current-change="(i) => (pageNum = i)"
        :page-count="pageNum"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import map from "../../datamap";
import api from "../api";
// import newApi from "@/newApi/bean.js";

let { bean, user } = api;
export default {
  name: "beanLogs",
  data() {
    return {
      map,
      loading: true,
      types: {},
      filter: {
        userId: "",
        type: "",
        startTime: "",
        endTime: "",
        role: "",
      },
      list: [],
      total: 0,
      pageNum: 1,
      limit: 30,
      partyS: {
        1: "甲方",
        2: "乙方",
      },
    };
  },
  watch: {
    pageNum() {
      this.fetch();
    },
  },
  methods: {
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }
      let { userId, type, startTime, endTime } = this.filter;
      let args = {
        pageNum: this.pageNum,
        limit: this.limit,
        userId,
        type,
        startTime: startTime || "",
        endTime: endTime || "",
        role: this.filter.role,
      };
      let res = await bean.logs(args);
      this.list = res.data.data;
      this.total = res.data.pageinfo.totalCount;
    },
    async getTypes() {
      let res = await bean.types();
      this.types = res.data.data;
    },
    async exportExcel() {
      this.loading = true;
      let { userId, type, startTime, endTime } = this.filter;
      let obj = {
        pageNum: this.pageNum,
        limit: this.limit,
        userId,
        type,
        startTime: startTime || "",
        endTime: endTime || "",
      };

      let resp = await bean.export(obj);
      let objectUrl = URL.createObjectURL(new Blob([resp.data]));
      let link = document.createElement("a");
      //   console.log(link);
      link.download = decodeURIComponent("云豆明细列表.xlsx");
      link.href = objectUrl;
      link.click();
    },
  },
  mounted() {
    this.getTypes();
    this.fetch(1);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/bean/logs.vue